import * as React  from 'react'
import { connect } from 'react-redux'

import Button               from '@material-ui/core/Button'
import CardActions          from '@material-ui/core/CardActions'
import CardContent          from '@material-ui/core/CardContent'
import ListItem             from '@material-ui/core/ListItem'
import ListItemText         from '@material-ui/core/ListItemText'
import ErrorOutline         from '@material-ui/icons/ErrorOutline'
import { FormattedMessage } from 'react-intl'

import { canInteractWithProcess }          from '../../project-utils/permissions'
import { selectAuthState }                 from '../../redux'
import { DateTimePicker, PermissionGuard } from '../atoms'
import { AppointmentFields }               from '../forms/types'
import { InjectedDialogControlProps }      from '../hocs/withDialogControls'
import withOnCommunicationSuccessClose     from '../hocs/withOnCommunicationSuccessClose'

interface AppointmentNotScheduledProps {
  onScheduleSubmit: (appointment: AppointmentFields) => void
}

type Props =
  AppointmentNotScheduledProps
  & ReturnType<typeof selectAuthState>
  & InjectedDialogControlProps

const SessionNotScheduled = ({
  isOpen,
  open,
  close,
  onScheduleSubmit,
}: Props) => {
  const phrasing = {
    noAppointmentScheduled:
      (
        <FormattedMessage
          id={'generic.noAppointmentScheduled'}
          defaultMessage={'No appointment scheduled'}
        />
      ),
    scheduleAppointmentPhysicallyPrompt:
      (
        <FormattedMessage
          id={'generic.scheduleAppointmentPhysicallyPrompt'}
          defaultMessage={'Talk to your counterpart and submit an appointment'}
        />
      ),
    scheduleNextAppointment:
      (
        <FormattedMessage
          id={'buttonActions.scheduleNextAppointment'}
          defaultMessage={'submit next appointment'}
        />
      ),
  }

  return (
    <>
      <CardContent>
        <ListItem disableGutters>
          <ErrorOutline color={'primary'} />
          <ListItemText
            primary={phrasing.noAppointmentScheduled}
            secondary={(
              <PermissionGuard check={canInteractWithProcess}>
                {phrasing.scheduleAppointmentPhysicallyPrompt}
              </PermissionGuard>
            )}
          />
        </ListItem>
      </CardContent>
      <PermissionGuard check={canInteractWithProcess}>
        <CardActions>
          <DateTimePicker
            value={''}
            onChange={onScheduleSubmit}
            TextFieldComponent={(props: any) => (
              <Button color={'primary'} {...props}>
                {phrasing.scheduleNextAppointment}
              </Button>
            )}
          />
        </CardActions>
      </PermissionGuard>
    </>
  )
}

export default connect(selectAuthState)(withOnCommunicationSuccessClose(SessionNotScheduled)) as any



// WEBPACK FOOTER //
// ./src/components/molecules/SessionNotScheduled.tsx